import axios from 'axios';
import { apiClient } from './apiClient';

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

// Separate axios instance for CSRF cookie endpoint
const csrfApi = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

/**
 * Fetch CSRF cookie from Laravel (required before login/register when backend validates CSRF).
 * Sets XSRF-TOKEN cookie; apiClient sends it via withCredentials and adds X-CSRF-TOKEN header from the same cookie.
 */
export const getCsrfToken = async () => {
  try {
    await csrfApi.get('/sanctum/csrf-cookie');
  } catch (error) {
    console.error('Failed to fetch CSRF cookie:', error);
    throw error;
  }
};

// Auth APIs - using Bearer token authentication (stateless)
export const register = async (data) => {
  // Get CSRF token first
  await getCsrfToken();
  
  const res = await apiClient.post('/api/v1/register', data);
  
  // Store the token from response
  if (res.data.token) {
    localStorage.setItem('authToken', res.data.token);
  }
  
  return res.data;
};

export const login = async (data) => {
  // Get CSRF token first
  await getCsrfToken();
  
  const res = await apiClient.post('/api/v1/login', data);
  
  // Store the token from response
  if (res.data.token) {
    localStorage.setItem('authToken', res.data.token);
  }
  
  return res.data;
};

export const logout = async () => {
  try {
    const res = await apiClient.post('/api/v1/logout');
    
    // Clear stored auth data
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    
    return res.data;
  } catch (error) {
    // Clear auth data even if logout fails
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    throw error;
  }
};

export const getCurrentUser = async () => {
  const res = await apiClient.get('/api/v1/user');
  return res.data;
};